var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPanelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 9.1665H10.8327V13.7498H9.16602V9.1665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95898 6.87516C8.95898 7.15143 9.06873 7.41638 9.26408 7.61173C9.45943 7.80708 9.72438 7.91683 10.0007 7.91683C10.2769 7.91683 10.5419 7.80708 10.7372 7.61173C10.9326 7.41638 11.0423 7.15143 11.0423 6.87516C11.0423 6.5989 10.9326 6.33394 10.7372 6.13859C10.5419 5.94324 10.2769 5.8335 10.0007 5.8335C9.72438 5.8335 9.45943 5.94324 9.26408 6.13859C9.06873 6.33394 8.95898 6.5989 8.95898 6.87516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPanelIcon);
export default __webpack_public_path__ + "static/media/infoPanelIcon.f63b891e4dd630f1a7e7d627c099f681.svg";
export { ForwardRef as ReactComponent };